var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDevplanWhite = function SvgDevplanWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M23.188 29.517a5.33 5.33 0 0 1 4.097-1.919h21.5c5.89 0 10.665-4.775 10.665-10.666V11.6C59.45 5.71 54.675.934 48.785.934h-4.168a5.33 5.33 0 0 0-4.097 1.919l-3.468 4.161a5.33 5.33 0 0 1-4.097 1.92h-21.5C5.565 8.933.789 13.707.789 19.598v5.333c0 5.89 4.775 10.665 10.666 10.665h4.168a5.33 5.33 0 0 0 4.097-1.919zM51.451 11.6a2.666 2.666 0 0 0-2.666-2.667h-8.168a5.33 5.33 0 0 0-4.097 1.919l-3.468 4.162a5.33 5.33 0 0 1-4.097 1.918h-17.5A2.666 2.666 0 0 0 8.788 19.6v5.333a2.666 2.666 0 0 0 2.667 2.666h8.168a5.33 5.33 0 0 0 4.097-1.919l3.468-4.161a5.33 5.33 0 0 1 4.096-1.92h17.5a2.666 2.666 0 0 0 2.667-2.666z",
    clipRule: "evenodd"
  })));
};
export default SvgDevplanWhite;